import { MAIN_HTTP_API_CONFIG } from '../../constants/api/mainHttp'

/**
 * Maps login/auth HTTP failures to short, user-facing copy.
 * @param {unknown} error - axios error or generic Error
 * @param {string} [fallback]
 * @returns {string}
 */
export function getLoginErrorMessage (error, fallback = 'Sign in failed. Please try again.') {
  const status = error?.response?.status
  const apiMessage = error?.response?.data?.message
  const validationErrors = error?.response?.data?.errors
  const apiBaseUrl = error?.config?.baseURL || MAIN_HTTP_API_CONFIG.URL || 'the API'

  if (validationErrors && typeof validationErrors === 'object') {
    const firstField = Object.keys(validationErrors)[0]
    const firstMessage = firstField && Array.isArray(validationErrors[firstField])
      ? validationErrors[firstField][0]
      : null
    if (typeof firstMessage === 'string' && firstMessage.trim()) {
      return firstMessage.trim()
    }
  }

  if (typeof apiMessage === 'string' && apiMessage.trim()) {
    if (status === 401 && apiMessage.toLowerCase().includes('invalid credentials')) {
      return 'Invalid email or password. Please check your credentials and try again.'
    }
    return apiMessage.trim()
  }

  if (status === 401) {
    return 'Invalid email or password. Please check your credentials and try again.'
  }

  if (status === 403) {
    return 'Sign in is not allowed for this account. Contact your administrator.'
  }

  if (status === 503) {
    return 'Sign in could not be completed due to a temporary server issue. Please try again.'
  }

  if (status >= 500) {
    return 'The server is temporarily unavailable. Please try again in a moment.'
  }

  if (!error?.response) {
    const code = error?.code || ''
    if (code === 'ERR_NETWORK' || error?.message === 'Network Error') {
      return `Cannot reach ${apiBaseUrl}. For local dev use http://localhost:5088 (see .env.development.local.example), start the API, and restart Vite.`
    }
    return `Cannot reach ${apiBaseUrl}. Check that the API is running and restart the web dev server after changing env files.`
  }

  return fallback
}
